import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const TagsQueryWithFiltersGql: DocumentNode = gql`
  query TagsQueryWithFilters(
    $first: Int!
    $connectionTypeFilter: String
    $hasActiveWarningFilter: Boolean
    $isCertifiedFilter: Boolean
    $isEmbeddedFilter: Boolean
    $name: String
    $offset: Int!
    $textSearch: String
  ) {
    tagsConnection(
      filter: { text: $name }
      first: $first
      offset: $offset
      orderBy: { field: NAME, direction: ASC }
    ) {
      totalCount
      nodes {
        id
        name
        databasesConnection(
          filter: {
            connectionType: $connectionTypeFilter
            isCertified: $isCertifiedFilter
            isEmbedded: $isEmbeddedFilter
            hasActiveWarning: $hasActiveWarningFilter
            text: $textSearch
          }
        ) {
          totalCount
        }
        databaseTablesConnection(
          filter: {
            connectionType: $connectionTypeFilter
            isCertified: $isCertifiedFilter
            isEmbedded: $isEmbeddedFilter
            hasActiveWarning: $hasActiveWarningFilter
            text: $textSearch
          }
        ) {
          totalCount
        }
      }
    }
  }
`;
